import gql from "graphql-tag";

export const GET_ADDITIONAL = gql`
  query additionalProducts($id: ID!) {
    shop {
      id
      collections(where: { id: $id }) {
        id
        products(where: { active: true }, orderBy: sort_ASC) {
          id
          name
          slug
          sort
          variants(orderBy: sort_ASC) {
            id
            available
            price
            priceCompareAt
            name
            weight
            sort
            product {
              name
              description(HTML: false)
            }
          }
        }
      }
    }
  }
`;

export const GET_SAUCE = gql`
  query getSauce {
    shop {
      id
      collections(where: { id: "cllm2uyhy55gx0839pax0e0kd" }) {
        id
        name

        products(where: { active: true }, orderBy: sort_ASC) {
          id
          name

          images {
            id
            url
          }

          variants(orderBy: sort_ASC) {
            id
            available
            price
            name
          }
        }
      }
    }
  }
`;
